import styles from './connect-agent.module.scss';
import Icon from '@ant-design/icons';
import Outgoing from '@/assets/icons/user-right-01.svg?react';
import Unanswered from '@/assets/icons/user-x-01.svg?react';
import AgentCall from '@/assets/icons/user-01.svg?react';
import clsx from 'clsx';

export interface ConnectAgentProps {
  type: 'outgoing' | 'agentCall' | 'unanswered';
}

interface IconData {
  containerStyles: string;
  iconStyles: string;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

const connectAgentData = {
  outgoing: {
    containerStyles: styles.containerOutgoing,
    iconStyles: styles.outgoingIconColor,
    icon: Outgoing,
  },
  agentCall: {
    containerStyles: styles.containerOutgoing,
    iconStyles: styles.outgoingIconColor,
    icon: AgentCall,
  },
  unanswered: {
    containerStyles: styles.containerUnanswered,
    iconStyles: styles.unansweredIconColor,
    icon: Unanswered,
  },
} satisfies Record<ConnectAgentProps['type'], IconData>;

export function ConnectAgent({ type }: ConnectAgentProps) {
  const { icon: IconComponent, containerStyles, iconStyles } = connectAgentData[type];

  return (
    <Icon
      className={clsx(styles.container, containerStyles)}
      component={() => (
        <IconComponent stroke={iconStyles} data-testid={`${type}-icon`} width={16} height={16} />
      )}
    />
  );
}
